import React from 'react';
import { isGetLinkType } from 'StaticBuilder/Utils';
import Note from './Note';
import AlertNote from './AlertNote';

const NoteWrapper = (props) => {
  if (isGetLinkType(window.CurrentDocumentInfo.type)) {
    return <AlertNote {...props} />;
  }
  return <Note {...props} />;
};

export default NoteWrapper;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NoteWrapper.jsx